<div class="overlay" *ngIf="isLoading$ | async">
    <span class="center"><mat-spinner></mat-spinner></span>
</div>